<template>
  <new-layout
    :backgroundImage="backgroundImage"
    :backgroundImage2x="backgroundImage2x"
    :showLogo="false"
  >
    <AccessSucceedCard class="success-card"/>
  </new-layout>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import NewLayout from '../components/NewLayout.vue';
import AccessSucceedCard from '../components/AccessSucceedCard.vue';
import ParcelexApi from '../../../services/parcelex';

export default {
  metaInfo: {
    title: 'Aprovado',
  },
  components: {
    NewLayout,
    AccessSucceedCard,
  },
  computed: {
    ...mapState('tracking', ['trackId']),
  },
  data() {
    return {
      backgroundImage: 'https://cdn.parcelex.com.br/assets/v3/persons/parcelex-guy-celebrating.png',
      backgroundImage2x: 'https://cdn.parcelex.com.br/assets/v3/persons/parcelex-guy-celebrating@2x.png',
    };
  },
  methods: {
    ...mapActions('tracking', ['setTrackId']),
    async sendEvent({ action, data }) {
      ParcelexApi.post('public/event/send', {
        action,
        source: 'login',
        origin: window.location.href.split('?')[0],
        data,
      }).catch((e) => console.error(e));
    },
  },
  async mounted() {
    if (this.trackId) {
      this.sendEvent({
        action: 'visualizou',
        data: {
          trackId: this.trackId,
          ctaSignInShowed: true,
          groupCode: this.createAccountGroupCode,
          userTestId: this.createAccountTrackTestId,
        },
      }).then((e) => console.warn(e));
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
